import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowStore } from "../../../../../store";
import { Chip, Grid } from "@mui/material";
import { OnlyPhoto } from "../../../../../../../libs/shared";

export const SellosArriboExporbananas = ({
  widthFull,
}: {
  widthFull: string;
}) => {
  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white", pt: 1 }}
    >
      <EtiquetaPuerta />
      <Grid item xs={12}>
        <EtiquetaVentoleras widthFull={widthFull} />
      </Grid>
      {/* <Grid item xs={12}>
        <EtiquetaVentolerasAdicional widthFull={widthFull} />
      </Grid> */}
      <EtiquetaPanelExterior />
    </Grid>
  );
};

const EtiquetaPuerta = () => {

  const {
    open: openEtExPuerta,
    handleClose: handleCloseEtExPuerta,
    handleOpen: handleOpenEtExPuerta,
  } = useOpen();

  const etiquetaExporPuertaPhoto = useWorkflowStore(
    (state) => state.etiquetaExporPuertaPhoto
  );

  const setEtiquetaExporPuertaPhoto = useWorkflowStore(
    (state) => state.setEtiquetaExporPuertaPhoto
  );
  const fotoUrl = useBlobUrl(etiquetaExporPuertaPhoto);


  return (
    <Grid
      item
      xs={12}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseEtExPuerta}
        handleOpen={handleOpenEtExPuerta}
        label="ETIQUETA PUERTA"
        open={openEtExPuerta}
        setFoto={setEtiquetaExporPuertaPhoto}
        width={240}
        fontSize={12}
      />
    </Grid>
  );
};

const EtiquetaVentoleras = ({ widthFull }: { widthFull: string }) => {
  return (
    <Grid
      container
      spacing={0}
      sx={{
        borderTop: "1px dashed darkgreen",
        pt: 6,
        pb: 2,
        position: "relative",
      }}
    >
      <Chip
        color="success"
        label="ETIQUETAS VENTOLERAS"
        sx={{ borderRadius: 1, position: "absolute", top: 5, left: 7 }}
      />
      <Grid item xs={5} sx={{ m: 1 }}>
        <EtiquetaVentolerasPhoto1 widthFull={widthFull} />
      </Grid>
      <Grid item xs={5} sx={{ m: 1 }}>
        <EtiquetasVentolerasPhoto2 widthFull={widthFull} />
      </Grid>
    </Grid>
  );
};

const EtiquetaVentolerasPhoto1 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openMaEtVen1,
    handleClose: handleCloseMaEtVen1,
    handleOpen: handleOpenMaEtVen1,
  } = useOpen();
  
  
  const macroEtiquetasVentolerasPhoto1 = useWorkflowStore(
    (state) => state.macroEtiquetasVentolerasPhoto1
  );
  
  const setMacroEtiquetasVentolerasPhoto1 = useWorkflowStore(
    (state) => state.setMacroEtiquetasVentolerasPhoto1
  );
  const fotoUrl = useBlobUrl(macroEtiquetasVentolerasPhoto1);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseMaEtVen1}
      handleOpen={handleOpenMaEtVen1}
      label="LADO IZQUIERDO"
      open={openMaEtVen1}
      setFoto={setMacroEtiquetasVentolerasPhoto1}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const EtiquetasVentolerasPhoto2 = ({ widthFull }: { widthFull: string }) => {

  const {
    open: openMaEtVen2,
    handleClose: handleCloseMaEtVen2,
    handleOpen: handleOpenMaEtVen2,
  } = useOpen();

  const setMacroEtiquetasVentolerasPhoto2 = useWorkflowStore(
    (state) => state.setMacroEtiquetasVentolerasPhoto2
  );

  const macroEtiquetasVentolerasPhoto2 = useWorkflowStore(
    (state) => state.macroEtiquetasVentolerasPhoto2
  );
  const fotoUrl = useBlobUrl(macroEtiquetasVentolerasPhoto2);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseMaEtVen2}
      handleOpen={handleOpenMaEtVen2}
      label="LADO DERECHO"
      open={openMaEtVen2}
      setFoto={setMacroEtiquetasVentolerasPhoto2}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const EtiquetaVentolerasAdicional = ({ widthFull }: { widthFull: string }) => {
  return (
    <Grid
      container
      spacing={0}
      sx={{
        borderTop: "1px dashed darkgreen",
        borderBottom: "1px dashed darkgreen",
        pt: 6,
        pb: 2,
        position: "relative",
      }}
    >
      <Chip
        color="success"
        label="ETIQUETAS VENTOLERAS ADICIONAL"
        sx={{ borderRadius: 1, position: "absolute", top: 5, left: 7 }}
      />
      <Grid item xs={5} sx={{ m: 1 }}>
        <PhotoEtiquetaVentolerasAdicional1 widthFull={widthFull} />
      </Grid>
      <Grid item xs={5} sx={{ m: 1 }}>
        <PhotoEtiquetaVentolerasAdicional2 widthFull={widthFull} />
      </Grid>
    </Grid>
  );
};

const PhotoEtiquetaVentolerasAdicional1 = ({
  widthFull,
}: {
  widthFull: string;
}) => {

  const {
    open: openMaEtVenAd1,
    handleClose: handleCloseMaEtVenAd1,
    handleOpen: handleOpenMaEtVenAd1,
  } = useOpen();


  const macroEtiquetasVentolerasAdicionalPhoto1 = useWorkflowStore(
    (state) => state.macroEtiquetasVentolerasAdicionalPhoto1
  );

  const setMacroEtiquetasVentolerasAdicionalPhoto1 = useWorkflowStore(
    (state) => state.setMacroEtiquetasVentolerasAdicionalPhoto1
  );

  const fotoUrl = useBlobUrl(macroEtiquetasVentolerasAdicionalPhoto1);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseMaEtVenAd1}
      handleOpen={handleOpenMaEtVenAd1}
      label="LADO IZQUIERDO"
      open={openMaEtVenAd1}
      setFoto={setMacroEtiquetasVentolerasAdicionalPhoto1}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const PhotoEtiquetaVentolerasAdicional2 = ({
  widthFull,
}: {
  widthFull: string;
}) => {

  const {
    open: openMaEtVenAd2,
    handleClose: handleCloseMaEtVenAd2,
    handleOpen: handleOpenMaEtVenAd2,
  } = useOpen();

  const macroEtiquetasVentolerasAdicionalPhoto2 = useWorkflowStore(
    (state) => state.macroEtiquetasVentolerasAdicionalPhoto2
  );

  const setMacroEtiquetasVentolerasAdicionalPhoto2 = useWorkflowStore(
    (state) => state.setMacroEtiquetasVentolerasAdicionalPhoto2
  );

  const fotoUrl = useBlobUrl(macroEtiquetasVentolerasAdicionalPhoto2);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseMaEtVenAd2}
      handleOpen={handleOpenMaEtVenAd2}
      label="LADO DERECHO"
      open={openMaEtVenAd2}
      setFoto={setMacroEtiquetasVentolerasAdicionalPhoto2}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const EtiquetaPanelExterior = () => {
  const {
    open: openEtiquetasPEExp,
    handleClose: handleCloseEtiquetasPEExp,
    handleOpen: handleOpenEtiquetasPEExp,
  } = useOpen();

  const setEtiquetasPanelExteriorExpPhoto = useWorkflowStore(
    (state) => state.setEtiquetasPanelExteriorExpPhoto
  );

  const etiquetasPanelExteriorExpPhoto = useWorkflowStore(
    (state) => state.etiquetasPanelExteriorExpPhoto
  );

  const fotoUrl = useBlobUrl(etiquetasPanelExteriorExpPhoto);

  return (
    <Grid
      item
      xs={12}
      sx={{
        mt: 2,
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseEtiquetasPEExp}
        handleOpen={handleOpenEtiquetasPEExp}
        label="ETIQUETA PANEL EXT."
        open={openEtiquetasPEExp}
        setFoto={setEtiquetasPanelExteriorExpPhoto}
        fontSize={12}
        width={240}
      />
    </Grid>
  );
};
